export default __webpack_public_path__ + "static/media/whatsapp.d0269408.png";